// @flow
export const imageDraft = [
	{
		featureFlags: [
			'unit_test_flag'
		],
		pathMap : {
			dirs : [
				{
					unit_test_path : 'unit_test_flag'		// eslint-disable-line camelcase
				}
			],
			files : [
				{
					'unit_test_path_2/unit_test_file_2' : 'unit_test_flag'
				}
			]
		}
	}
];
/*
How to move an image/images or a folder of images behind a feature flag:

Let the paths for some images be:
 "res/img/apps/lang1/product1_mac_image.png"
 "res/img/apps/lang1/product2_mac_image.png"
 "res/img/apps/lang2/product1_mac_image.png"
 "res/img/apps/lang2/product2_mac_image.png"


CASE 1 (MOVING FOLDER BEHIND FEATURE FLAG):
We want to make changes to only lang1 for all products.
Therefore we move this folder behind the feature flag "flag1" and the new path to be used for new modified images becomes:

 "res/img/apps/product1/lang1/flag1/product1_mac_image.png"
 "res/img/apps/product1/lang1/flag1/product2_mac_image.png"
 "res/img/apps/product1/lang2/product1_mac_image.png"
 "res/img/apps/product1/lang2/product2_mac_image.png"


 Entry that the coder needs to make in the image_drafts file:

 {
  "featureFlags": [
    "flag1"
  ],
  "pathMap" : {
    "dirs" : [{
      "res/img/apps/product1/lang1" : "flag1"
    }],
    "files" : [{}]
  }
 }

 CASE 2 (MOVING FILES BEHIND FEATURE FLAG):
 We want to make changes to only product1 images in lang1.
 Therefore we move these images behind the feature flag "flag2" and the new path to be used for new modified images becomes:
 "res/img/apps/lang1/flag2/product1_mac_image.png"
 "res/img/apps/lang1/product2_mac_image.png"
 "res/img/apps/lang2/product1_mac_image.png"
 "res/img/apps/lang2/product2_mac_image.png"

 Entry that the coder needs to make in the image_drafts file:

 {
  "featureFlags": [
    "flag2"
  ],
  "pathMap" : {
    "dirs" : [{}],
    "files" : [{
      "res/img/apps/product1/lang1/product1_" : "flag2"
    }]
  }
 }
 */
